jQuery.fn.liveFilter = function(list, hiddenClass, callback){
  list = jQuery(list);

  if ( list.length ) {
    var rows = list.children('li'),
      cache = rows.map(function(){
        return $(this).attr('data-title').toLowerCase();//this.innerHTML.toLowerCase();
      });

    this
      .keyup(filter).keyup()
      .parents('form').submit(function(){
        return false;
      });
  }

  return this;

  function show(rows) {
    if (hiddenClass) {
      rows.removeClass(hiddenClass);
    } else {
      rows.show();
    }
  }

  function hide(rows) {
    if (hiddenClass) {
      rows.addClass(hiddenClass);
    } else {
      rows.hide();
    }
  }

  function filter(){
    var term = jQuery.trim( jQuery(this).val().toLowerCase() ), scores = [];

    if ( !term ) {
      show(rows);
    } else {
      hide(rows);

      cache.each(function(i){
        var score = this.score(term);
        if (score > 0) { scores.push([score, i]); }
      });

      jQuery.each(scores.sort(function(a, b){return b[0] - a[0];}), function(){
        show(jQuery(rows[ this[1] ]));
      });
    }

    if (callback) {
      callback.call(null, this);
    }
  }
};